export enum TradingAccountAction {

    None,
    SignUp,
    Switch,
}
